import Link from '../../views/Download';
import { connect } from 'react-redux';
import { actions } from '../../../state/assessment';
import { actions as authactions } from '../../../state/auth';
import { actions as statusactions } from '../../../state/status';
import { push } from 'connected-react-router';

const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  intel: ownProps.match.params.intel,
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  membername: state.shift.assessment.membername,
  memberusername: state.shift.assessment.memberusername,
  memberemail: state.shift.assessment.memberemail,
  membertelephone: state.shift.assessment.membertelephone,
  memberrole: state.shift.assessment.memberrole,
  memberstatus: state.shift.assessment.memberstatus,
  nextaction: state.shift.assessment.nextaction
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      // dispatch(authactions.logout()).then(() =>
      //   dispatch(push(`/${locale}/login`))
      // );
      dispatch(authactions.logout())
        .then(dispatch(()=>{
          localStorage.clear();
          sessionStorage.clear();
          actions.resetAssessmentStore();
          statusactions.resetStatus();
          window.location.reload();
        }));
    },

    downloadHandler: value => {
      dispatch(authactions.logout()).then(() =>
        dispatch(push(`/${locale}/login`))
      );

      //window.close();
    },

    approveSubmitHandler: role => {
      dispatch(actions.saveapproval(role));
    },

    approveRejectHandler: () => {
      dispatch(actions.saverejection());
    }
    // approveRejectHandler: () => {
    //   dispatch((authactions.logout()).then(() =>
    //       dispatch(push(`/${locale}/login`))
    //     ));
    // }
  };
};

const Download = connect(
  mapStateToProps,
  mapDispatchToProps
)(Link);

export default Download;



// WEBPACK FOOTER //
// ./src/components/container/Download/index.js